import React from "react";

export default function CookiePolicy() {
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "40px 20px", lineHeight: "1.7" }}>
      <h1>Cookie Policy</h1>

      <p><strong>Last updated:</strong> May 2026</p>

      <h2>What Are Cookies?</h2>
      <p>
        Cookies are small files stored on your device when you visit a website.
        They help websites work properly and improve user experience.
      </p>

      <h2>How We Use Cookies</h2>
      <p>Client Exchange uses cookies for:</p>

      <ul>
        <li>User login and authentication</li>
        <li>Security and fraud prevention</li>
        <li>Payment processing</li>
        <li>Website performance</li>
        <li>Analytics and traffic monitoring</li>
      </ul>

      <h2>Third-Party Services</h2>

      <p>We may use trusted third-party providers including:</p>

      <ul>
        <li>Stripe</li>
        <li>Google Analytics</li>
        <li>Google Accounts</li>
      </ul>

      <h2>Managing Cookies</h2>

      <p>
        Most browsers allow you to disable or manage cookies in browser settings.
        Some parts of the website may not function correctly if cookies are disabled.
      </p>

      <h2>Contact</h2>

      <p>support@clientexchange.com.au</p>
    </div>
  );
}